import React from 'react';
import GeneralModal from '../../../../components/UI/modal/GeneralModal';
import useTags from '../../../../hooks/useTags';
import checkReqStatusModalLang from '../../../../data/lang/homePage/checkReqStatusModal.lang';
import { useCheckReqStatusModalData, useCloseCheckReqStatusModal } from '../../../../stores/checkReqStatusModal.store';
import ExistBtn from '../../../../components/buttons/ExistBtn';


const CheckReqStatusModal = () => {

    const generateTag = useTags();
    const { isCheckReStatusModalOpen, requestStatus } = useCheckReqStatusModalData();
    const closeCheckReqStatusModal = useCloseCheckReqStatusModal();

    const modalTitleTag = generateTag(checkReqStatusModalLang, 'modal-title');
    const statusPanddingTag = generateTag(checkReqStatusModalLang, 'status-pandding');
    const statusApprovedTag = generateTag(checkReqStatusModalLang, 'status-approved');
    const statusRejectedTag = generateTag(checkReqStatusModalLang, 'status-rejected');


    return (
        <GeneralModal
            show={isCheckReStatusModalOpen}
            closingFunc={closeCheckReqStatusModal}
            title={modalTitleTag}
            modalSize='S'
            body={(
                <div className='p-4 fs-3 text-center'>
                    {requestStatus === 1 && statusPanddingTag}
                    {requestStatus === 2 && statusApprovedTag}
                    {requestStatus === 3 && statusRejectedTag}
                </div>
            )}
            footer={(
                <ExistBtn onClick={closeCheckReqStatusModal} />
            )}
        />
    );
}

export default CheckReqStatusModal;